import styled from 'styled-components'
import { RiAppsLine } from 'react-icons/ri'
import { useModalStack } from '../../context/modalStackContext'
import AppSwitcherModal from '../appSwitcher/AppSwitcherModal'
import { media } from '../../styles/media'

const Pill = styled.div`
  display: flex;
  align-items: center;
  background: ${({ theme }) => theme.area.bg};
  border-radius: 2rem;
  padding: 4px;
  position: relative;

  @media (min-width: 1000px) 
  {
    &:hover span {
      opacity: 1;
      visibility: visible;
    }

  }
  @media (max-width: 389px) {
    display: none;
  }

  ${media.phone} {
    padding-inline: 0px;
  }
`

const Tooltip = styled.span`
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateY(65px) translateX(-50%);
  background: ${({ theme }) => theme.dropdown.background};
  color: ${({ theme }) => theme.font.label};
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;

  opacity: 0;
  visibility: hidden;
  transition: 0.2s;
`;

const IconButton = styled.button`
  border-radius: 50%;
  background-color: transparent;
  color: ${({ theme }) => theme.font.label};
  border: none;
  width: 44px;
  height: 44px;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
  transition: background-color 0.15s, color 0.15s;

  &:hover {
    background: ${({ theme }) => theme.dropdown.selectedBackground};
  }
`

function AppSwitcherToggle() {
  const { pushModal, stack } = useModalStack()

  const handleOpen = () => {
    if (stack.length > 0) return
    pushModal(AppSwitcherModal)
  }

  return (
    <Pill>
      <IconButton onClick={handleOpen} data-testid='appSwitcher.toggle'>
        <RiAppsLine />
        <Tooltip>CTRL + K</Tooltip>
      </IconButton>
    </Pill>
  )
}

export default AppSwitcherToggle
